(() => {
  if (window.burnoutsCartTrackingReady) return;
  window.burnoutsCartTrackingReady = true;
  document.addEventListener('ajaxProduct:added', function (event) {
    const product = event.detail && event.detail.product;
    if (!product || !window._learnq || typeof window._learnq.push !== 'function') return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || !privacy.marketingAllowed()) return;
    window._learnq.push(['track', 'Added to Cart', {
      ProductID: product.product_id,
      VariantID: product.variant_id || product.id,
      ProductName: product.product_title || product.title,
      Quantity: product.quantity,
      Price: product.price / 100,
      URL: product.url
    }]);
  });
})();
